import usePermissions from './usePermissions';

/**
 * Hook wrapper pour maintenir la compatibilité avec le code existant
 * Utilise le hook usePermissions corrigé en interne
 * @param {Object} options - Options du hook
 * @param {string} options.userId - ID de l'utilisateur
 * @returns {Object} Objet contenant les fonctions de vérification des permissions
 */
export const useAdvancedPermissions = (options = {}) => {
  // Utiliser le hook usePermissions corrigé
  const {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isAdmin,
    permissions,
    loading,
    error,
    refetch
  } = usePermissions(options);

  // Retourner les mêmes fonctions pour maintenir la compatibilité
  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isAdmin,
    permissions,
    loading,
    error,
    refetch
  };
};

export default useAdvancedPermissions;
